import { ServiceInstance } from "../models/service-instance";
import { ServiceService } from "../services/service.service";
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

export const ServiceTypeUuidParameter = "serviceTypeUuid";

/**
 * Resolver used to load the all the Service Instances of given Service Type (by UUID).
 */
@Injectable()
export class ServiceInstancesOfTypeResolver implements Resolve<ServiceInstance[]> {

  constructor(
    private serviceService: ServiceService
  ) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ServiceInstance[]> {
    const serviceTypeUuid: string = route.data[ServiceTypeUuidParameter];

    try {
        return await this.serviceService.getAllServiceInstancesOfServiceType(serviceTypeUuid);
    } catch (error) {
        console.error(`Problem obtaining Services of Type: '${serviceTypeUuid}' during page transition.`, error);
        throw error;
    }
  }

}
